import { Modal } from 'antd';
import { Box } from '@mui/material';
import { useState, useRef } from 'react';
import SliderList from '../components/slider/SliderList';
import SliderForm from '../components/slider/SliderForm';
import PageHeader from '../components/common/PageHeader';
import { ViewCarouselOutlined as SliderIcon } from '@mui/icons-material';

const SliderPage = () => {
  const listRef = useRef();
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalVisible(true);
  };

  const handleSuccess = () => {
    setIsModalVisible(false);
    setSelectedItem(null);
    listRef.current?.refresh();
  };

  return (
    <Box className="premium-container">
      <PageHeader
        title="Home Slider Items"
        subtitle="Manage images and content displayed on the main home page slider."
        titleIcon={<SliderIcon />}
        btnText="ADD SLIDE"
        onBtnClick={() => {
          setSelectedItem(null);
          setIsModalVisible(true);
        }}
      />

      {/* List Container */}
      <Box className="premium-table-card">
        <SliderList
          ref={listRef}
          onEdit={handleEdit}
        />
      </Box>

      <Modal
        title={selectedItem ? 'Edit Slide' : 'Add Slide'}
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedItem(null);
        }}
        footer={null}
        width={800}
      >
        <SliderForm
          initialValues={selectedItem}
          onSuccess={handleSuccess}
          onCancel={() => {
            setIsModalVisible(false);
            setSelectedItem(null);
          }}
        />
      </Modal>
    </Box>
  );
};

export default SliderPage;
